import React, {useEffect, useState} from 'react'
import ReactDOM, {unmountComponentAtNode} from 'react-dom'
import {DataObjectId} from 'yougile-model'
import {OptionsItemCheckbox} from '@components/common/base/dropdown-button-menu/types'
import {
  SelectedColumns,
  SelectedColumnsProps
} from '@components/movement-templates/selected-columns'
import {UIElement} from '../ui-element'

export class ColumnSelectWrapper extends UIElement {
  public props: SelectedColumnsProps
  private previous: HTMLElement
  public setProps?: (props: SelectedColumnsProps) => void
  private controlled: boolean
  constructor(
    companyId: DataObjectId,
    props: SelectedColumnsProps,
    controlled = false
  ) {
    super(companyId, undefined, undefined)
    this.props = props
    this.controlled = controlled
  }

  public rerender(props: SelectedColumnsProps) {
    this.props = {
      ...this.props,
      ...props
    }
    this.setProps?.(this.props)
  }

  public override render(el: HTMLElement): void {
    el.innerHTML = ''
    el.className = 'ui-button-new'

    this.clean()

    renderElement(this, el, this.controlled)
    super.render(el)

    this.previous = el
  }

  public clean() {
    // to avoid memory leaks
    this.previous && unmountComponentAtNode(this.previous)
  }
}

const ColumnSelectBase = ({
  controller,
  controlled
}: {
  controller: ColumnSelectWrapper
  controlled: boolean
}) => {
  const [columns, setColumns] = useState(controller.props.columns)
  const [props, setProps] = useState(controller.props)

  useEffect(() => {
    controller.setProps = setProps
    return () => {
      if (controller.setProps === setProps) {
        controller.setProps = undefined
      }
    }
  }, [])

  const onChange = (value: OptionsItemCheckbox[]) => {
    props.onChange?.(value)
    setColumns(value)
  }

  return (
    <SelectedColumns
      {...props}
      columns={controlled ? props.columns : columns}
      onChange={onChange}
    />
  )
}

export const renderElement = (
  controller: ColumnSelectWrapper,
  element: HTMLElement,
  controlled = false
) => {
  ReactDOM.render(
    <ColumnSelectBase controller={controller} controlled={controlled} />,
    element
  )
}
